<script>

    export let icon = null
    export let text = ''
    export let tooltip = null
    export let type = 'button'
    export let color = ''
    export let size = ''
    export let iconType = 'fa'
    export let fullwidth = false
    export let loading = false
    export let style = null

</script>

<button on:click type={type} style={style} class="button is-{color} is-{size}" data-tooltip={tooltip} class:is-fullwidth={fullwidth} class:is-loading={loading}>
    {#if icon}
        <span class="icon"><i class="fas { iconType }-{ icon }"></i></span>
    {/if}
    {#if text}
        <span>{ text }</span>
    {/if}
</button>